export default __webpack_public_path__ + "static/media/el_star-alt-gray.0699147d.svg";